import React from 'react';
import { Link } from 'react-router-dom';

const RelatedRooms = ({ relatedRooms, checkInDate, checkOutDate, totalrooms, totalguest }) => {
  return (
    relatedRooms.length > 0 && (
      <section className="section-b-space bg-white mt-5">
        <div className="container">
          <div className="title-1 title-5">
            <h2>Related Hotels</h2>
            <p>Explore other amazing options that might interest you</p>
          </div>
          <div className="row">
            {relatedRooms.map(room => (
              <div className="col-lg-4 col-md-4 mb-4" key={room.id}>
                <div className="hotel-box">
                  <div className="hotel-image">
                    <Link to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}>
                      <img
                        src={`https://admin.abhyaranyan.com/RoomsUploadimage/${room.roomImage}`}
                        className="img-fluid"
                        alt={room.roomType}
                      />
                      {room.isSpecial && (
                        <div className="special-label">
                          <span>Special</span>
                        </div>
                      )}
                    </Link>
                  </div>
                  <div className="hotel-details">
                    <div className="hotel-info">
                      <div className="hotel-title-box">
                        <h5>
                          <Link to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}>
                            {room.roomType}
                          </Link>
                        </h5>
                        <h6><i className="fas fa-map-marker-alt"></i> {room.location}</h6>
                      </div>
                    </div>
                    <div className="hotel-price">
                      {room.oldRent > room.rent && (
                        <del>₹{room.oldRent}</del>
                      )}
                      <h6>₹{room.rent}</h6>
                      <Link
                        to={`/viewrooms?id=${room.id}&checkInDate=${checkInDate}&checkOutDate=${checkOutDate}&totalrooms=${totalrooms}&totalguest=${totalguest}`}
                        className="btn btn-solid btn-sm"
                      >
                        Book Now
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  );
};

export default RelatedRooms;
